<div class="container">
    <div class="card p-3">
        <h4>{{textDisplay}}</h4>

        <form class="">
            <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
                <p>{{modelError}}</p>
            </div>

            <div class="row">
                <div class="mb-3 mr-0 col">
                    <div class="dropdown">
                        <label class="form-label">Question Type</label>
                        <ng-select [readonly]="true" class="form-select form-control" id="questionType"
                            name="questionType" [(ngModel)]="question.questionType"
                            (ngModelChange)="onQuestionTypeChange()">
                            <ng-option value="" disabled selected>Select Question Type</ng-option>
                            <ng-option *ngFor="let type of questionTypes"
                                [value]="type.value">{{type.label}}</ng-option>
                        </ng-select>
                    </div>
                </div>

                <div class="mb-3 mr-0 col">
                    <label class="form-label">Category</label>
                    <ng-select class="form-select" [(ngModel)]="question.category"
                        [ngModelOptions]="{ standalone: true }">
                        <ng-option selected value="0" disabled>Select Category</ng-option>
                        <ng-option selected value="0" disabled *ngIf="categoryList.length<=0">No Category</ng-option>
                        <ng-option *ngFor="let cat of categoryList" [value]="cat">{{cat}}</ng-option>
                    </ng-select>
                </div>


            </div>

            <div class="row">
                <div class="mb-3 mr-0 col">
                    <label class="form-label">Marks</label>
                    <input class="form-control" type="number" min="0" [(ngModel)]="question.marks"
                        [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="mb-3 mr-0 col">
                    <label class="form-label">Penalty Marks</label>
                    <input class="form-control" id="modelError" type="number" min="0"
                        [(ngModel)]="question.penaltyMarks" [ngModelOptions]="{ standalone: true }">
                </div>
            </div>

            <div class="row">
                <div class="mb-3 mr-0 col">
                    <div class="dropdown">
                        <label class="form-label">Language</label>
                        <ng-select class="form-select form-control" id="language" name="language"
                            [(ngModel)]="question.language">
                            <ng-option value="" disabled selected>Select Language</ng-option>
                            <ng-option *ngFor="let lang of languages" [value]="lang.code">{{lang.lang}}</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="mb-3 mr-0 col" *ngIf="question.questionType === 'Essay'">
                    <label class="form-label">Max. Word Count</label>
                    <input class="form-control" type="number" min="0" [(ngModel)]="question.maxWordCount"
                        [ngModelOptions]="{ standalone: true }">
                </div>
            </div>

            <div class="row ml-1 mb-1" *ngIf="question.id > 0">
                <div class="form-check col">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="question.disabled"
                        [ngModelOptions]="{ standalone: true }">
                    <label class="form-check-label" for="flexCheckDefault">
                        Disable Question
                    </label>
                </div>
            </div>

            <div class="row">
                <label class="form-label">Question Editor</label>
                <app-quill-editor [(ngModel)]="question.questionHtml" [ngModelOptions]="{ standalone: true }"
                    [height]="'500px'" [placeholder]="'Type your text here...'">
                </app-quill-editor>
            </div>

            <hr>

            <!-- Multiple Choice Options -->
            <ng-container
                *ngIf="question.questionType === 'OptionsOnly' || question.questionType === 'Multiple-Choice'">
                <h5 class="form-label mt-4">Options</h5>
                <div class="row row-cols-3">
                    <div class="col mt-2" *ngFor="let option of question.options; let i = index">
                        <div class="row ml-1">
                            <div class="form-check col">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="option.answer"
                                    [ngModelOptions]="{ standalone: true }">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Answer
                                </label>
                            </div>
                            <div class="col d-flex flex-column align-items-end">
                                <span class="cursorP" (click)="removeOption(i)">x</span>
                            </div>
                        </div>

                        <app-quill-editor [(ngModel)]="option.optionHtml" [ngModelOptions]="{ standalone: true }"
                            [height]="'150px'"></app-quill-editor>
                    </div>
                </div>
                <div class="d-flex flex-column align-items-end">
                    <Button class="btn btn-secondary mt-2" (click)="pushOption()">+ Add New Option</Button>
                </div>
            </ng-container>

            <!-- Short Answer Questions -->
            <ng-container *ngIf="question.questionType === 'SAQ'  || question.questionType === 'Short Answer Question'">
                <div class="mb-3 mr-0 col">
                    <label class="form-label">SAQ Possible Answers (separator '|')</label>
                    <input class="form-control" type="text" [(ngModel)]="question.saqPossibleAnswers"
                        [ngModelOptions]="{ standalone: true }">
                </div>
            </ng-container>

            <!-- Essay Questions -->
            <ng-container *ngIf="question.questionType === 'Essay'">
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <h5 class="form-label mt-4">Sub Questions</h5>
                    <button class="btn btn-sm btn-secondary mt-4" (click)="pushEssaySubQuestion()">+ Add New
                        Sub-Question</button>
                </div>

                <!-- Render essay Sub-Questions -->
                <div *ngFor="let subQuestion of question.essaySubQuestions; let i = index"
                    class="row g-2 align-items-start mt-3">
                    <div class="col-auto pt-2">
                        <label>{{ (subQuestion.questionNoLabel || getLetter(i)) + '.' }}</label>
                    </div>

                    <div class="col">
                        <app-quill-editor [(ngModel)]="subQuestion.questionHtml" [ngModelOptions]="{ standalone: true }"
                            [maxHeight]="'120px'" [placeholder]="'Type your text here...'"
                            class="w-100"></app-quill-editor>
                    </div>

                    <div class="col-md-2">
                        <label class="form-label">Marks</label>
                        <input class="form-control" type="number" min="0" [(ngModel)]="subQuestion.marks"
                            [ngModelOptions]="{ standalone: true }" />
                    </div>
                </div>

                <!-- Remove last Sub-Question button -->
                <div class="text-end mt-3" *ngIf="question.essaySubQuestions?.length > 0">
                    <button class="btn btn-sm btn-danger" (click)="removeEssaySubQuestion()">
                        − Remove Last Sub-Question
                    </button>
                </div>
            </ng-container>

            <div class="">
                <div class="row mt-3">
                    <div class="mb-3 mr-0 col" *ngIf="!isSave">
                        <input class="form-control bg-primary text-white" type="button" value="Update Question"
                            (click)="saveQuestion(true)">
                    </div>
                    <div class="mb-3 mr-0 col" *ngIf="isSave">
                        <input class="form-control bg-primary text-white" type="button" value="Save Question"
                            (click)="saveQuestion()">
                    </div>
                    <div class="mb-3 mr-0 col" *ngIf="isSave">
                        <input class="form-control bg-secondary text-white" type="button" value="Cancel"
                            (click)="goBack()">
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>